import * as actionTypes from "../constants/actionTypes";

// reducer initial state
export const initialState = {
  byIds: {},
  allIds: [],
  loaded: false,
  fetching: false,
  error: undefined
};

function setModels(state, models) {
  const byIds = models;
  const allIds = Object.keys(byIds);

  return {
    ...state,
    byIds,
    allIds
  };
}

function setModel(state, model) {
  const byIds = { ...state.byIds, [model.id]: model };
  const allIds = Object.keys(byIds);

  return {
    ...state,
    byIds,
    allIds
  };
}

function unsetModel(state, id) {
  const { [id]: omit, ...byIds } = state.byIds;
  const allIds = Object.keys(byIds);

  return {
    ...state,
    byIds,
    allIds
  };
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_MODELS:
      return setModels(state, action.payload.models);
    case actionTypes.SET_MODEL:
      return setModel(state, action.payload.model);
    case actionTypes.UNSET_MODEL:
      return unsetModel(state, action.payload.id);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/models.js